import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useActiveSale } from '../hooks/useActiveSale';

function SaleBanner() {
  const { sale, loading } = useActiveSale();
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    if (!sale) return;

    const updateCountdown = () => {
      const now = new Date().getTime();
      const end = new Date(sale.endDate).getTime();
      const remaining = end - now;

      if (remaining <= 0) {
        setTimeLeft(null);
        return;
      }

      const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [sale]);

  if (loading || !sale) return null;

  return (
    <Box
      component={Link}
      to="/purchase"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: 1, sm: 1.5 },
        py: 1,
        px: 2,
        bgcolor: 'text.primary',
        color: 'background.default',
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
          opacity: 0.9,
        },
      }}
    >
      <Typography sx={{ color: 'inherit', fontWeight: 700, fontSize: '0.9rem' }}>
        {sale.name}: {sale.percentOff}% OFF
      </Typography>

      {timeLeft && (
        <Box sx={{ display: { xs: 'none', sm: 'flex' }, gap: 0.5, alignItems: 'center' }}>
          <Typography sx={{ color: 'inherit', fontWeight: 600, fontSize: '0.85rem' }}>
            Ends in {timeLeft.days}d {String(timeLeft.hours).padStart(2, '0')}h {String(timeLeft.minutes).padStart(2, '0')}m
          </Typography>
        </Box>
      )}

      <Typography
        sx={{
          color: 'inherit',
          fontWeight: 600,
          fontSize: '0.85rem',
          display: { xs: 'none', sm: 'block' },
        }}
      >
        View pricing
      </Typography>
    </Box>
  );
}

export default SaleBanner;
